import cn from 'classnames';
import * as React from 'react';
import { useMemo } from 'react';
import { useHistory } from 'react-router-dom';

import { routes } from '../../../constants/routing';
import { useWL } from '../../../contexts/ThemeProvider';
import { BUTTON_BUTTON } from '../../../types/forms';

import { ReactComponent as IERectLogoDark } from '../../../assets/images/iex-black-logo-only-img.svg';
import { ReactComponent as IERectLogoLight } from '../../../assets/images/iex-white-logo-only-img.svg';
import { isLightColor } from '../../../utils/ui';

import styles from './NavHeader.module.scss';

interface IProps {
  expanded: boolean;
}

const NavHeader = ({ expanded }: IProps) => {
  const history = useHistory();

  const theme = useWL();

  const sideBarColor = useMemo(() => {
    return theme?.portal_sidebar_color;
  }, [theme?.portal_sidebar_color]);

  const navHeaderClasses = cn(styles.navHeader, expanded ? styles.expanded : styles.collapsed);

  const handleOnClick = React.useCallback(() => history.push(routes.dashboard), [history]);

  const isBackgroundLight = React.useMemo(() => {
    return isLightColor(sideBarColor);
  }, [sideBarColor]);

  const poweredByLogoMarkup = React.useMemo(() => {
    return (
      <div className={styles.poweredByContainer}>
        <span className={styles.text}>Powered by</span>
        {isBackgroundLight ? <IERectLogoDark className={styles.image} /> : <IERectLogoLight className={styles.image} />}
      </div>
    );
  }, [isBackgroundLight]);

  return (
    <div className={navHeaderClasses}>
      <button type={BUTTON_BUTTON} className={styles.logo} onClick={handleOnClick} data-action="header_logo">
        <div className={cn(styles.expandedLogo, { [styles.visible]: expanded })}>
          {theme?.org_rect_logo && poweredByLogoMarkup}
        </div>
        <div className={cn(styles.collapsedLogo, { [styles.visible]: !expanded })} />
      </button>
    </div>
  );
};

export default NavHeader;
